import { Classes, Icon } from '@blueprintjs/core';
import * as React from 'react';
import { connect } from 'react-redux';

import type { RootState } from 'vms/app/rootReducer';

import { selectLocationsListSorted } from './selectors';
import type { Location } from './types';

interface Props {
  locations: Location[];
  selected: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  name: string;
  disabled?: boolean;
}

const LocationSelect = ({
  locations,
  selected,
  onChange,
  name,
  disabled = false,
}: Props) => (
  <div className={Classes.HTML_SELECT}>
    <select value={selected} onChange={onChange} name={name} disabled={disabled}>
      <option value="">---</option>
      {locations.map((loc) => (
        <option key={loc.id} value={loc.id}>
          {loc.name}
        </option>
      ))}
    </select>
    <Icon icon="double-caret-vertical" />
  </div>
);

const mapState = (state: RootState) => ({ locations: selectLocationsListSorted(state) });
export default connect(mapState)(LocationSelect);
